"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SimulatorDataResource_1 = __importDefault(require("./SimulatorDataResource"));
const class_transformer_1 = require("class-transformer");
const Resource_1 = __importDefault(require("../Resource"));
const ProductResponseResource_1 = __importDefault(require("../Product/ProductResponseResource"));
const EProductCategories_1 = require("../../enums/Scpi/EProductCategories");
const ProductSheetFileLightResponseResource_1 = __importDefault(require("./File/ProductSheetFileLightResponseResource"));
const ProductSheetTemplateFileLightResponseResource_1 = __importDefault(require("./File/DocumentsTemplates/ProductSheetTemplateFileLightResponseResource"));
const UserPublicResponseResource_1 = __importDefault(require("../User/UserPublicResponseResource"));
const SocieteDeGestionResponseResource_1 = __importDefault(require("./SocieteDeGestion/SocieteDeGestionResponseResource"));
const ETechnicalSignature_1 = require("../../enums/ProductSheet/ETechnicalSignature");
const DemembrementKeyResponseResource_1 = __importDefault(require("./DemembrementKey/DemembrementKeyResponseResource"));
const ProductSheetFiscalInfoResponseResource_1 = __importDefault(require("./ProductSheetFiscalInfoResponseResource"));
class ProductSheetResponseResource extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.ifiDate = null;
        this.ifiValue = null;
        this.createdAt = null;
        this.updatedAt = null;
        this.product = null;
        this.ProductToFiles = [];
        this.ProductDocumentsTypeToFiles = [];
        this.demembrementKeys = [];
        this.fiscalInfo = null;
    }
}
exports.default = ProductSheetResponseResource;
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SimulatorDataResource_1.default),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "simulatorData", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSheetResponseResource.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSheetResponseResource.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSheetResponseResource.prototype, "description", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], ProductSheetResponseResource.prototype, "price", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "dueDays", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "dueMonths", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "minNumberOfShares", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "distributionRate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "distributionRateNet", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "distributionRateN2", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "distributionRateDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "distributionRateN2Date", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "distributionFrequency", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "capitalization", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "ifiDate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "ifiValue", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "financialOccupancyRate", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "retainedEarnings", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "subFees", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "withdrawalPrice", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "updatedAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSheetResponseResource.prototype, "productId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSheetResponseResource.prototype, "technicalSignatureType", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductResponseResource_1.default),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "product", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductSheetFileLightResponseResource_1.default),
    __metadata("design:type", Array)
], ProductSheetResponseResource.prototype, "ProductToFiles", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductSheetTemplateFileLightResponseResource_1.default),
    __metadata("design:type", Array)
], ProductSheetResponseResource.prototype, "ProductDocumentsTypeToFiles", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ProductSheetResponseResource.prototype, "category", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UserPublicResponseResource_1.default),
    __metadata("design:type", UserPublicResponseResource_1.default)
], ProductSheetResponseResource.prototype, "creator", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "isSignable", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SocieteDeGestionResponseResource_1.default),
    __metadata("design:type", SocieteDeGestionResponseResource_1.default)
], ProductSheetResponseResource.prototype, "societeDeGestion", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DemembrementKeyResponseResource_1.default),
    __metadata("design:type", Array)
], ProductSheetResponseResource.prototype, "demembrementKeys", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ProductSheetFiscalInfoResponseResource_1.default),
    __metadata("design:type", Object)
], ProductSheetResponseResource.prototype, "fiscalInfo", void 0);
